import { mergeDeep } from '../utils/config.js';
import { defaultConfig } from './default-config.js';
import { defaultConfig as defaultConfigAlt } from './default-configAlt.js';

/**
 * Konfiguracja sceny - merge z domyślną
 */
export const synthConfig = mergeDeep({}, defaultConfig);
console.log('synthConfig', synthConfig);

// export const synthConfig = mergeDeep({}, defaultConfigAlt, {
//     // sun: {
//     //     size: 80,
//     //     positionX: 0,
//     //     positionY: 0.3,
//     //     color: 0x9510FC
//     // },
//     // ground: {
//     //     linesCount: 20,
//     //     lineWidth: 2.099,
//     //     glowIntensity: 0.5,
//     //     verticalRandomness: 0.5,
//     //     blockNewSegments: false,
//     //     bloom: {
//     //         enabled: true,
//     //         threshold: 0.1,
//     //         strength: 0.2,
//     //         radius: 0.4
//     //     },
//     //     lineBreaks: {
//     //         horizontal: true,
//     //         vertical: false,
//     //         position: 'even',
//     //         strength: 0.15,
//     //         count: 2,
//     //         skipVerticalForBreaks: true
//     //     }
//     // },
//     // camera: {
//     //     speed: 0.23,
//     //     fov: 75
//     // },
//     // render: {
//     //     pixelRatio: null,
//     //     resolutionScale: 0.85
//     // }
// });

